import React from "react";
import Gambar from "../Images/VectorImageLanding.svg";

function LandingChat({ origin }) {
  if (origin) {
    return (
      <div className="landingContainerOrigin">
        <div className="landingChat">
          <img src={Gambar} className="gambarLanding"></img>
          <span className="textInfoHeader">
            Welcome to Centerix Omnichannel
          </span>
          <span className="textInfo">Let's get started!</span>
        </div>
      </div>
    );
  } else {
    return (
      <div className="landingContainer">
        <div className="landingChat2">
          <img src={Gambar} className="gambarLanding"></img>
          <span className="textInfoHeader">
            Welcome to Centerix Omnichannel
          </span>
          <span className="textInfo">Let's get started!</span>
        </div>
      </div>
    );
  }
}

export default LandingChat;
